import { useWatch } from 'react-hook-form';
var ENABLE_SPACE_RESERVATION_VISIBILITY = 'enable-space-reservation-visibility';
export function useSpacePrivacySettings(spaces) {
    var isPrivate = useWatch({
        name: 'isPrivateEvent',
    });
    var spaceReservationVisibilityEnabled = !spaces.length ||
        spaces.some(function (space) {
            var _a, _b;
            return String((_b = (_a = space.settings) === null || _a === void 0 ? void 0 : _a.find(function (setting) { return setting.slug === ENABLE_SPACE_RESERVATION_VISIBILITY; })) === null || _b === void 0 ? void 0 : _b.value) === 'true';
        });
    var shouldShowPrivacyIndicator = !spaceReservationVisibilityEnabled && isPrivate;
    return {
        spaceReservationVisibilityEnabled: spaceReservationVisibilityEnabled,
        shouldShowPrivacyIndicator: shouldShowPrivacyIndicator,
    };
}
